import CallerIDAndroid from './CallerTrackerAndroid.svg';
import CallerIDiOS from './CallerIDiOS.svg';
import CardManager from './CardManager.svg';
import ContactRequest from './ContactRequest.svg';
import DisableAddOn from './DisableAddOn.svg';
import GoalManager from './GoalManager.svg';
import ManageEntity from './ManageEntity.svg';
import MicrosoftTeams from './MicrosoftTeams.svg';
import OutlookPlugin from './OutlookPlugin.svg';
import Products from './Products.svg';
import SalesOrders from './SalesOrders.svg';
import GeolocatedOpportunities from './GeolocatedOpportunities.svg';
import Campaigns from './Campaigns.svg';
import NewsManager from './NewsManager.svg';
import EmailTracking from './EmailTracking.svg';
import DanaPlus from './DanaPlus.svg';

export default {
    CallerIDAndroid,
    CallerIDiOS,
    CardManager,
    ContactRequest,
    DisableAddOn,
    GoalManager,
    ManageEntity,
    MicrosoftTeams,
    OutlookPlugin,
    Products,
    SalesOrders,
    GeolocatedOpportunities,
    Campaigns,
    NewsManager,
    EmailTracking,
    DanaPlus,
};
